import { render, staticRenderFns } from "./changes-log.vue?vue&type=template&id=251275e9&scoped=true&"
import script from "./changes-log.vue?vue&type=script&lang=js&"
export * from "./changes-log.vue?vue&type=script&lang=js&"
import style0 from "./changes-log.vue?vue&type=style&index=0&id=251275e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251275e9",
  null
  
)

export default component.exports